<section id="profile-info">
                <div class="row">
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div class="form-group mb-2">
                            <div class="card">
                                <div class="card-header">
                                    <h2>Faculty</h2>
                                </div>
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-md-4">
                                            <small>Name</small>
                                            <input class="form-control" [(ngModel)]="name"/>
                                        </div>
                                        <div class="col-md-4">
                                            <small>Designation</small>
                                            <input class="form-control" [(ngModel)]="designation"/>
                                        </div>
                                        <div class="col-md-4">
                                            <small>Photo</small>
                                            <input class="form-control" type="file" accept="image/*"
                                                   (change)="onPhotoSelected($event)">
                                            <small *ngIf="uploadingPhoto">Uploading...</small>
                                            <img *ngIf="photoPreviewUrl" [src]="photoPreviewUrl"
                                                 class="img-fluid rounded mt-1" style="max-height: 60px" alt="Photo preview"/>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-footer">
                                    <button class="btn btn-primary pull-right" rippleEffect
                                            (click)="addDetail()" [disabled]="submitting">
                                        <span class="font-weight-bold">Add</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div class="card">
                            <div class="card-body">
                                <table class="table table-list">
                                    <thead>
                                    <tr>
                                        <th class="text-center">
                                            <h6 class="mt-1 mb-1 font-weight-bold">Photo</h6>
                                        </th>
                                        <th class="text-center">
                                            <h6 class="mt-1 mb-1 font-weight-bold">Name</h6>
                                        </th>
                                        <th class="text-center">
                                            <h6 class="mt-1 mb-1 font-weight-bold">Designation</h6>
                                        </th>
                                        <th class="text-center">
                                            <h6 class="mt-1 mb-1 font-weight-bold">Action</h6>
                                        </th>
                                    </tr>
                                    </thead>
                                    <tbody *ngIf="faculties && faculties.length > 0; else noDataToShowWeb">
                                    <tr *ngFor="let faculty of faculties">
                                        <td class="text-center">
                                            <img *ngIf="faculty?.photo_file?.url" [src]="faculty.photo_file.url"
                                                 class="img-fluid rounded" style="max-height: 40px" alt="Photo"/>
                                        </td>
                                        <td class="text-center">
                                            <h6 class="mt-1">{{faculty?.name}}</h6>
                                        </td>
                                        <td class="text-center">
                                            <h6 class="mt-1">{{faculty?.designation}}</h6>
                                        </td>
                                        <td class="text-center">
                                            <i class="fas fa-trash font-small-4 text-danger cursor-pointer"
                                               (click)="delete(faculty.id)"></i>
                                        </td>
                                    </tr>
                                    </tbody>
                                    <ng-template #noDataToShowWeb>
                                        <tbody>
                                        <tr>
                                            <td class="text-center" colspan="4">
                                                <h6 class="mt-1">No data to show</h6>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </ng-template>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
